import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async show(id: string) {
    return useAsyncData('campaign-invitation-show', () => this.call(`/spa/campaigns/invitations/${id}`))
  }

  async update(id: string, data: any) {
    return this.call(`/spa/campaigns/invitations/${id}`, {
      method: 'put',
      body: data,
    })
  }

  async accept(id: string) {
    return this.call(`/spa/campaigns/invitations/${id}`, {
      method: 'post',
    })
  }

  async reject(id: string, data: any) {
    return this.call(`/spa/campaigns/invitations/${id}`, {
      method: 'delete',
      body: data,
    })
  }

  async downloadServiceContract(id: string) {
    return this.call(`/spa/campaigns/invitations/${id}/contract`, {
      method: 'get',
    })
  }
}
